if (!customElements.get('zuqo-lazy-image')) {
  const waiting = new Set();
  const queue = new Set();
  let frame = null;
  const mobile = window.matchMedia('(max-width: 749px)').matches;
  const schedule = callback => mobile ? setTimeout(callback, 0) : requestAnimationFrame(callback);
  let ready = false;
  const flush = () => {
    frame = null;
    let count = 0;
    for (const element of queue) {
      queue.delete(element);
      if (!element.isConnected) continue;
      element.reveal();
      if (++count === (mobile ? 1 : 4)) break;
    }
    if (queue.size) frame = schedule(flush);
  };
  const enqueue = element => {
    queue.add(element);
    if (frame === null) frame = schedule(flush);
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      enqueue(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: window.matchMedia('(max-width: 749px)').matches ? '400px 0px' : '500px 0px' }) : null;
  const collectionObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      enqueue(entry.target);
      collectionObserver.unobserve(entry.target);
    });
  }, { rootMargin: '600px 0px' }) : null;
  const observe = element => {
    if (observer) observer.observe(element);
    else enqueue(element);
  };
  customElements.define('zuqo-lazy-image', class extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('template')) return;
      if (this.classList.contains('zuqo-category__lazy-media')) {
        if (collectionObserver) collectionObserver.observe(this);
        else enqueue(this);
        return;
      }
      if (ready) observe(this);
      else waiting.add(this);
    }
    disconnectedCallback() {
      observer?.unobserve(this);
      collectionObserver?.unobserve(this);
      waiting.delete(this);
      queue.delete(this);
    }
    reveal() {
      const template = this.querySelector('template');
      if (!template) return;
      const content = template.content.cloneNode(true);
      content.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      this.replaceChildren(content);
      observer?.unobserve(this);
      collectionObserver?.unobserve(this);
      queue.delete(this);
      waiting.delete(this);
    }
  });
  const start = () => {
    if (ready) return;
    ready = true;
    waiting.forEach(element => { if (element.isConnected) observe(element); });
    waiting.clear();
  };
  const initialize = () => {
    const hero = document.querySelector('.zuqo-hero__image');
    if (!hero) { start(); return; }
    let scheduled = false;
    const afterPaint = () => {
      if (scheduled) return;
      scheduled = true;
      hero.removeEventListener('load', afterPaint);
      hero.removeEventListener('error', afterPaint);
      requestAnimationFrame(() => requestAnimationFrame(start));
    };
    if (hero.complete) afterPaint();
    else {
      hero.addEventListener('load', afterPaint, { once: true });
      hero.addEventListener('error', afterPaint, { once: true });
    }
    setTimeout(start, 2500);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
}


(() => {
  const observe = (root = document) => {
    const images = root.querySelectorAll('.zuqo-category__media img[loading="lazy"], .zuqo-subcollections__media img[loading="lazy"]');
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.loading = 'eager';
      entry.target.fetchPriority = 'auto';
      observer.unobserve(entry.target);
    }), {rootMargin:'800px 0px'});
    images.forEach(image => observer.observe(image));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => observe(), {once:true});
  else observe();
  document.addEventListener('shopify:section:load', event => observe(event.target));
})();
